const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export const toImageUrl = (url: string | null | undefined): string => {
  if (!url) return 'https://via.placeholder.com/300x300?text=No+Image';
  if (url.startsWith('http')) return url;
  return BASE_URL + url;
};
